import {
  get,
  post,
  update,
} from '../helpers'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDataPermission(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/admin/rules/permission/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addDataPermission(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/admin/rules/permission', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeDataPermission(ctx, userData) {
      return new Promise((resolve, reject) => {
        update('/admin/rules/permission', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDatas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        get('/admin/rules/list', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchData(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/admin/rules/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addData(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/admin/rules', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateData(ctx, userData) {
      return new Promise((resolve, reject) => {
        update('/admin/rules', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
